import produce from 'immer';
import {
	SET_LOAD_QUEUE_TYPE, LOAD_QUEUE_LIST_REQUEST, LOAD_QUEUE_LIST,
	LOAD_QUEUE_COUNT, LOAD_QUEUE_APPROVED, UNLOAD_SITE_QUEUE_LIST,
	LOAD_QUEUE_APPROVAL_CANCELLED, LOAD_TRIP_LIST_REQUEST, LOAD_TRIP_LIST,
	SET_SELECTED_LOAD_IDS, SET_LOAD_HISTORY_SHOW_MODAL, SET_LOAD_HISTORY_PARAMS,
	PLAN_ANALYZE_INFO, CREW_ANALYZE_INFO, EG_ANALYZE_INFO, PICKED_LIST, PICKED_LIST_REQUEST,
	TOTAL_LOAD_TRIP_COUNT_REQUEST, TOTAL_LOAD_TRIP_COUNT, SET_LOAD_QUEUE_SEARCH_TEXT, SET_LOAD_QUEUE_INPUTS,
	SET_LOAD_QUEUE_SORT_ORDER, SET_LOAD_QUEUE_FILTER_IDS, SET_LOAD_QUEUE_FILTERS, SET_FARM_SWITCHED, SET_LOAD_TIMELINE_REQUEST, SET_LOAD_TIMELINE, SET_TARE_LOAD_REQUESTING, SET_TARE_LOAD, UPDATE_TARE_LOAD, UPDATE_LOAD_LIST, SET_AI_CHAT_BOT, SET_AI_CHAT_MESSAGE, SET_AI_CHAT_BOT_ID, GET_LOAD_REGION_LIST, GET_LOAD_REGION_LIST_REQUESTING, GET_LOAD_SOURCE_EG_LIST, GET_LOAD_SOURCE_EG_LIST_REQUESTING, SET_PLANTING_QUEUE_INPUTS,
	REMOVE_LOAD_QUEUE_DATA, SET_ISCOMPLETE, SET_IS_NEED_PLANTER_VALUES,
	LOAD_QUEUE_CUSTOMER_LIST,
	LOAD_QUEUE_CUSTOMER_LIST_REQUEST,SET_LOAD_HISTORY_RELOAD,
} from '../constants/action-types';

const initialState = {
	loadHistory: {
		params: {
			farmId: null,
			crewId: null,
			egId: null
		},
		showModal: false
	},
	tareLoadHistory: {
		isRequesting: false,
		data: [],
		loadDetails: {
			totalCount: 0,
			totalCapacity: 0,
			totalLoadSeconds: 0
		},
		totalLoadTripCount: 0
	},
	pickedLoadList: {
		isRequesting: false,
		data: [],
		isTotalCountRequesting: false,
		totalLoadTripCount: 0
	},
	loadQueueType: 1,
	loadQueueCount: 0,
	loadQueueSearchText: '',
	loadQueueSortOrder: 2,
	loadQueueFilterIds: null,
	loadQueueFilters: null,
	loadQueueInput: {
		offloadGeoShapeId: null,
		offloadStorageLocationId: null,
		offloadStoragePipe: null
	},
	loadQueueList: {
		isRequesting: false,
		data: []
	},
	loadQueueCustomerList: {
		isRequesting: false,
		data: []
	},
	unLoadSiteList: [],
	selectedLoadIds: [],
	loadTripList: {
		isRequesting: false,
		payload: []
	},
	loadTimeLine: {
		isRequesting: false,
		data: []
	},
	isAiChatBot: "",
	isShowChatBotRoom: 0,
	aiChatBotMessages: [
		// { type: "bot", message: "Hi,How can i help you" },
	],
	aiChatBotId: "",
	regionList: {
		isRequesting: false,
		data: []
	},
	sourceEGList: {
		isRequesting: false,
		data: []
	},
	plantingQueueInput: {
		fieldShapeId: null,
		planterId: null,
		loadCapacity: null,
		fieldRegionId: null
	},
	isComplete: false,
	isNeedPlanterValues: true,
	loadHistoryReload: false
}

export default (state = initialState, action) => {
	switch (action.type) {
		case SET_LOAD_HISTORY_SHOW_MODAL: {
			state = {
				...state,
				loadHistory: {
					...state.loadHistory,
					showModal: action.payload ? action.payload : false
				}
			};
			break;
		}
		case SET_LOAD_HISTORY_PARAMS: {
			state = {
				...state,
				loadHistory: {
					...state.loadHistory,
					params: { ...initialState.loadHistory.params, ...action.payload ? action.payload : {} }
				}
			};
			break;
		}
		case PLAN_ANALYZE_INFO: {
			state = {
				...state,
				loadHistory: {
					...state.loadHistory,
					params: {
						...state.loadHistory.params,
						...action.payload.farmId ? { farmId: action.payload.farmId } : {},
						crewId: null, egId: null
					}
				}
			}
			break;
		}
		case CREW_ANALYZE_INFO: {
			state = {
				...state,
				loadHistory: {
					...state.loadHistory,
					params: {
						...state.loadHistory.params,
						crewId: action.payload.crewId,
						egId: null
					}
				}
			}
			break;
		}
		case EG_ANALYZE_INFO: {
			state = {
				...state,
				loadHistory: {
					...state.loadHistory,
					params: {
						...state.loadHistory.params,
						crewId: action.payload.crewId,
						egId: action.payload.egId
					}
				}
			}
			break;
		}
		case SET_LOAD_QUEUE_TYPE:
			state = { ...state, loadQueueType: action.payload };
			break;
		case LOAD_QUEUE_COUNT:
			if (action && action.payload && action.payload.hasOwnProperty('incomplete_count')) {
				state = {
					...state, loadQueueCount: action.payload && action.payload.incomplete_count ?
						action.payload.incomplete_count : initialState.loadQueueCount
				};
			} else if (action && action.payload && action.payload.hasOwnProperty('notapproved_count')) {
				state = {
					...state, loadQueueCount: action.payload && action.payload.notapproved_count ?
						action.payload.notapproved_count : initialState.loadQueueCount
				};
			} else {
				state = {
					...state, loadQueueCount: initialState.loadQueueCount
				};
			}
			break;
		case LOAD_QUEUE_LIST_REQUEST:
			state = { ...state, loadQueueList: { isRequesting: true, data: [] } };
			break;
		case LOAD_QUEUE_LIST: {
			const loadList = (action.payload || initialState.loadQueueList.data);
			state = {
				...state,
				loadQueueCount: (state.loadQueueType === 1) ? loadList.length : state.loadQueueCount,
				loadQueueList: { isRequesting: false, data: loadList }
			};
			break;
		}
		case LOAD_QUEUE_CUSTOMER_LIST_REQUEST:
			state = { ...state, loadQueueCustomerList: { isRequesting: true, data: [] } };
			break;
		case LOAD_QUEUE_CUSTOMER_LIST: {
			const loadCustomerList = (action.payload || initialState.loadQueueCustomerList.data);
			state = {
				...state,
				loadQueueCustomerList: { isRequesting: false, data: loadCustomerList }
			};
			break;
		}
		case LOAD_QUEUE_APPROVED: {
			const loadIds = Array.isArray(action.payload.loads)
				? action.payload.loads.map(item => item.load_activity_uuid)
				: [action.payload.load_activity_uuid];
			const loadList = state.loadQueueList.data
				.filter(e => loadIds.indexOf(e.loadActivityId) < 0);
			state = {
				...state,
				loadQueueCount: (state.loadQueueType === 1) ? loadList.length : state.loadQueueCount,
				loadQueueList: { ...state.loadQueueList, data: loadList }
			};
			break;
		}
		case LOAD_QUEUE_APPROVAL_CANCELLED: {
			const loadList = state.loadQueueList.data
				.filter(e => e.loadActivityId !== action.payload.load_activity_uuid);
			state = {
				...state,
				loadQueueCount: state.loadQueueCount + 1,
				loadQueueList: { ...state.loadQueueList, data: loadList }
			};
			break;
		}
		case UNLOAD_SITE_QUEUE_LIST: {
			state = { ...state, unLoadSiteList: action.payload || initialState.unLoadSiteList };
			break;
		}
		case LOAD_TRIP_LIST_REQUEST:
			state = { ...state, loadTripList: { isRequesting: true, payload: [] } };
			break;
		case LOAD_TRIP_LIST: {
			const loadTrips = (action.payload || initialState.loadTripList.payload);
			state = { ...state, loadTripList: { isRequesting: false, payload: loadTrips } };
			break;
		}
		case SET_SELECTED_LOAD_IDS: {
			state = { ...state, selectedLoadIds: action.payload ? action.payload : state.selectedLoadIds }
			break;
		}
		case SET_LOAD_QUEUE_INPUTS: {
			state = {
				...state, loadQueueInput: {
					...initialState.loadQueueInput,
					...state.loadQueueInput,
					...action.payload || {}
				}
			};
			break;
		}
		case PICKED_LIST_REQUEST: {
			state = produce(state, s => {
				s.pickedLoadList.isRequesting = true;
				s.pickedLoadList.data = [];
			});
			break;
		}
		case TOTAL_LOAD_TRIP_COUNT_REQUEST: {
			state = produce(state, s => {
				s.pickedLoadList.isTotalCountRequesting = true;
			});
			break;
		}
		case TOTAL_LOAD_TRIP_COUNT: {
			state = produce(state, s => {
				s.pickedLoadList.isTotalCountRequesting = false;
				s.pickedLoadList.totalLoadTripCount = (action.payload || {}).total_load_trip_count || 0;
			});
			break;
		}
		case PICKED_LIST: {
			state = produce(state, s => {
				s.pickedLoadList.isRequesting = false;
				s.pickedLoadList.data = action.payload || [];
			});
			break;
		}
		case SET_LOAD_QUEUE_SEARCH_TEXT: {
			state = produce(state, s => {
				s.loadQueueSearchText = action.payload || '';
			});
			break;
		}
		case SET_LOAD_QUEUE_SORT_ORDER: {
			state = produce(state, s => {
				s.loadQueueSortOrder = action.payload || initialState.loadQueueSortOrder;
			});
			break;
		}
		case SET_LOAD_QUEUE_FILTER_IDS: {
			state = produce(state, s => {
				s.loadQueueFilterIds = action.payload || initialState.loadQueueFilterIds;
			});
			break;
		}
		case SET_LOAD_QUEUE_FILTERS: {
			state = produce(state, s => {
				s.loadQueueFilters = action.payload || initialState.loadQueueFilters;
			});
			break;
		}
		case SET_FARM_SWITCHED: {
			state = produce(state, s => {
				s.loadQueueFilters = initialState.loadQueueFilters;
				s.loadQueueFilterIds = initialState.loadQueueFilterIds;
				s.loadQueueSortOrder = initialState.loadQueueSortOrder;
				s.loadQueueInput = initialState.loadQueueInput;
			});
			break;
		}
		case SET_LOAD_TIMELINE_REQUEST: {
			state = produce(state, s => {
				s.loadTimeLine.isRequesting = true;
			});
			break;
		}
		case SET_LOAD_TIMELINE: {
			state = produce(state, s => {
				s.loadTimeLine.isRequesting = false;
				s.loadTimeLine.data = action.payload ? action.payload : [];
			});
			break;
		}
		case SET_TARE_LOAD_REQUESTING: {
			state = produce(state, s => {
				s.tareLoadHistory.isRequesting = true;
				s.tareLoadHistory.data = [];
				s.tareLoadHistory.loadDetails = initialState.tareLoadHistory.loadDetails;
			});
			break;
		}
		case SET_TARE_LOAD: {
			const { payload } = action;

			if (!payload) {
				state = produce(state, s => {
					s.tareLoadHistory = initialState.tareLoadHistory;
				});

				break;
			}

			const loadDetails = {
				totalCount: payload.load.total_count,
				totalCapacity: payload.load.total_capacity,
				totalLoadSeconds: payload.load.total_load_seconds
			}

			state = produce(state, s => {
				s.tareLoadHistory.isRequesting = false;
				s.tareLoadHistory.data = payload.history;
				s.tareLoadHistory.loadDetails = loadDetails;
			});
			break;
		}
		case UPDATE_TARE_LOAD: {
			const { payload } = action;
			const { updatedData, updatedLoadCapacity } = payload

			if (!updatedData || !updatedLoadCapacity) {
				state = produce(state, s => {
					s.tareLoadHistory = initialState.tareLoadHistory;
				});

				break;
			}

			state = produce(state, s => {
				s.tareLoadHistory.data = updatedData;
				s.tareLoadHistory.loadDetails.totalCapacity = updatedLoadCapacity;
			});
			break;
		}
		case SET_AI_CHAT_BOT: {
			const { payload } = action;
			// if (!payload) {
			//     state = produce(state, s => {
			//         s.isAiChatBot = initialState.isAiChatBot;
			//     });

			//     break;
			// }
			state = produce(state, s => {
				s.isAiChatBot = payload.aiStatus;
				s.isShowChatBotRoom = payload.selectedViewType;
			});
			break;
		}
		case SET_AI_CHAT_MESSAGE: {
			const { payload } = action;
			if (!payload) {
				state = produce(state, s => {
					s.aiChatBotMessages = initialState.aiChatBotMessages;
				});

				break;
			}
			state = produce(state, s => {
				s.aiChatBotMessages = payload;
			});
			break;
		}
		case SET_AI_CHAT_BOT_ID: {
			const { payload } = action;
			if (!payload) {
				state = produce(state, s => {
					s.aiChatBotId = initialState.aiChatBotId;
				});

				break;
			}
			state = produce(state, s => {
				s.aiChatBotId = payload;
			});
			break;
		}
		case UPDATE_LOAD_LIST:
			const { load, data } = action;
			const filteredLoad = state.loadQueueList.data.find((each) => each.loadActivityId === load.loadActivityId);
			const updatedLoad = {
				...filteredLoad, ...data
			}
			let modifiedLoads = filteredLoad ? [...state.loadQueueList.data.filter((each) => each.loadActivityId !== load.loadActivityId)] : [];
			if (updatedLoad) modifiedLoads.push(updatedLoad);
			state = {
				...state,
				loadQueueList: { isRequesting: false, data: modifiedLoads }
			};

			break;
		case REMOVE_LOAD_QUEUE_DATA: {
			const { loadActivityId } = action;
			let modifiedLoads = [...state.loadQueueList.data.filter((each) => each.loadActivityId !== loadActivityId)];
			state = {
				...state,
				loadQueueList: { isRequesting: false, data: modifiedLoads }
			};
			break;
		}
		case GET_LOAD_REGION_LIST_REQUESTING: {
			state = produce(state, s => {
				s.regionList.data = [];
				s.regionList.isRequesting = true
			});
			break;
		}
		case GET_LOAD_REGION_LIST: {
			state = produce(state, s => {
				s.regionList.data = action.payload;
				s.regionList.isRequesting = false
			});
			break;
		}
		case GET_LOAD_SOURCE_EG_LIST_REQUESTING: {
			state = produce(state, s => {
				s.sourceEGList.data = [];
				s.sourceEGList.isRequesting = true
			});
			break;
		}
		case GET_LOAD_SOURCE_EG_LIST: {
			state = produce(state, s => {
				s.sourceEGList.data = action.payload;
				s.sourceEGList.isRequesting = false
			});
			break;
		}
		case SET_PLANTING_QUEUE_INPUTS: {
			state = {
				...state, plantingQueueInput: {
					...initialState.plantingQueueInput,
					...state.plantingQueueInput,
					...action.payload || {}
				}
			};
			break;
		}
		case SET_ISCOMPLETE: {
			state = { ...state, isComplete: action.payload };
			break;
		}
		case SET_IS_NEED_PLANTER_VALUES: {
			state = { ...state, isNeedPlanterValues: action.payload };
			break;
		}
		case SET_LOAD_HISTORY_RELOAD: {
			state = { ...state, loadHistoryReload: action.payload };
			break;
		}
		default:
			break;
	}
	return state;
}
